import { createBrowserRouter } from 'react-router-dom';
import { Layout } from '@/components/Layout';
import { ProtectedRoute } from '@/components';
import Home from '@/pages/Home';
import Signin from '@/pages/SignIn';
import Signup from '@/pages/SignUp';
import ServiceCenter from '@/pages/ServiceCenter';
import SagawaExp from '@/pages/SagawaExp';
import HanedaShop from '@/pages/HanedaShop';
import Vip from '@/pages/Vip';
import AITrip from '@/pages/AITrip';
import DestinationEmbed from '@/pages/DestinationEmbed';
import Orders from '@/pages/Orders';
import CarRental from '@/pages/CarRental';
import CarRentalReserve from '@/pages/CarRental/Reserve';
import Coupon from '@/pages/Coupon/Index';
import Profile from '@/pages/Profile';
import CouponList from '@/pages/Coupon/List';
import Protocol from '@/pages/Protocol';
import MineCoupon from '@/pages/Coupon/Mine';


const router = createBrowserRouter([
  {
    path: '/',
    element: <Layout />,
    children: [
      {
        index: true,
        element: <Home />,
      },
      {
        path: '/service-center',
        element: <ServiceCenter />,
      },
      {
        path: '/sagawa-exp',
        element: <SagawaExp />,
      },
      {
        path: '/haneda-shop',
        element: <HanedaShop />,
      },
      {
        path: '/vip',
        element: <Vip />,
      },
      {
        path: '/ai-trip',
        element: <AITrip />,
      },
      {
        path: '/destination/:slug',
        element: <DestinationEmbed />,
      },
      {
        path: '/car-rental',
        element: <CarRental />,
      },
      {
        path: '/car-rental/reserve',
        element: (
          <ProtectedRoute>
            <CarRentalReserve />
          </ProtectedRoute>
        ),
      },
      // {
      //   path: '/coupon',
      //   element: <Coupon />,
      // },
      {
        path: '/coupon-list',
        element: (
          <ProtectedRoute>
            <CouponList />
          </ProtectedRoute>
        ),
      },
      {
        path: '/mine-coupon',
        element: (
          <ProtectedRoute>
            <MineCoupon />
          </ProtectedRoute>
        ),
      },
      {
        path: '/orders',
        element: (
          <ProtectedRoute>
            <Orders />
          </ProtectedRoute>
        ),
      },
      {
        path: '/profile',
        element: (
          <ProtectedRoute>
            <Profile />
          </ProtectedRoute>
        ),
      },
    ],
  },
  {
    path: '/signin',
    element: <Signin />,
  },
  {
    path: '/signup',
    element: <Signup />,
  },
  {
    path: '/protocol',
    element: <Protocol />,
  },
]); 

export default router;